import React from 'react';
import { PropTypes } from 'prop-types';
import styled, { css, keyframes } from 'styled-components';
import Colors from 'constants/Colors';

export const SpinnerSize = {
  SMALL: 1,
  MEDIUM: 2,
  BIG: 3
};

const propTypes = {
  size: PropTypes.number,
  color: PropTypes.string
};

const defaultProps = {
  size: SpinnerSize.SMALL,
  color: Colors.PRIMARY
};

const rotate360 = keyframes`
  from {
    transform: rotate(0deg);
  }

  to {
    transform: rotate(360deg);
  }
`;

const Wrapper = styled.div`
  display: inline-block;
  position: relative;
  backface-visibility: hidden;
`;

const Content = styled.div`
  animation: ${rotate360} 0.7s linear infinite;
  border-radius: 50%;
  box-shadow: 0 ${({ size }) => size}px 0 0 ${({ color }) => color};

  ${({ size }) =>
    size &&
    css`
      width: calc(50px * ${size});
      height: calc(50px * ${size});
    `}
`;

const Spinner = ({ size, color, ...props }) => (
  <Wrapper>
    <Content size={size} color={color}></Content>
  </Wrapper>
);

Spinner.propTypes = propTypes;
Spinner.defaultProps = defaultProps;

export default Spinner;
